import React from 'react';
import { useGetHeaderButtons } from './hooks';
import { ButtonsListContainer } from 'components/Button';

const ProteinVariantHeader = (props) => {
  const { setShowModal, saveVariants, isDirty, onDiscardButtonClick, isError } = props;
  const saveCancelButtons = useGetHeaderButtons(
    setShowModal,
    saveVariants,
    isDirty,
    onDiscardButtonClick,
    isError,
  );

  return (
    <>
      <div id="proteinvariantview-view-header" className="protein-variant-view-header">
        <div
          id="proteinvariantview-view-header-title"
          className="protein-variant-view-header-title"
        >
          Create Protein Variant
        </div>
        <div
          id="proteinvariantview-view-header-button"
          className="protein-variant-view-header-button-container"
        >
          <ButtonsListContainer
            containerStyleClass="align-items-center"
            buttonsList={saveCancelButtons}
          />
        </div>
      </div>
    </>
  );
};

export default ProteinVariantHeader;
